import type { Immutable } from "immer";
import React from "react";

import { Context, templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { offersPageComponentsMap } from "../../blocks/componentMaps";

import styles from "./index.module.scss";

const OffersIcon = (
    props: Immutable<{
        href: string;
        imgSrc: string;
        imgAlt: string;
        title: string;
        copy: React.ReactNode;
    }>,
): React.JSX.Element => (
    <li className={styles.icon}>
        <a href={props.href}>
            <div>
                <img
                    className="responsive"
                    src={props.imgSrc}
                    alt={props.imgAlt}
                    loading="lazy"
                    decoding="async"
                />
            </div>
            <h5 className={styles.iconTitle}>{props.title}</h5>
            <p className={concatClassNames([styles.iconCopy, "caption-light"])}>
                {props.copy}
            </p>
        </a>
    </li>
);

export const OffersPageBody = (
    props: Immutable<Omit<templates.OffersPageTemplate, "page_chrome">>,
): React.JSX.Element => {
    const chrome = React.useContext(Context).chrome;
    const heroBg = `${chrome.static_base}img/offers/hero-offers.jpg`;
    const guaranteeIcon = (n: number): string =>
        `${chrome.static_base}img/global/guarantee/guarantee-icon-${n}.png`;
    return (
        <>
            <section
                className={concatClassNames([styles.hero, "hero"])}
                style={{
                    background: `url(${heroBg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "top center",
                    backgroundSize: "cover",
                }}
            >
                <div className="main-container">
                    <h1 className={styles.heroTitle}>
                        {props.page.hero_title}
                    </h1>
                </div>
            </section>
            <section>
                {props.page.offers_blocks ? (
                    <StreamField
                        tagName={React.Fragment}
                        value={props.page.offers_blocks.value}
                        components={offersPageComponentsMap}
                    />
                ) : null}
            </section>
            <div className="main-container">
                <div className={styles.iconsContainer}>
                    <ul className={styles.iconsList}>
                        <OffersIcon
                            href={props.support_url}
                            imgSrc={guaranteeIcon(1)}
                            imgAlt="100 Night Risk-Free Trial"
                            title="100 Night Risk-Free Trial"
                            copy="If you don’t love your new mattress, we’ll make it right with hassle-free returns or exchanges."
                        />
                        <OffersIcon
                            href={props.support_url}
                            imgSrc={guaranteeIcon(2)}
                            imgAlt="Free Shipping"
                            title="Free Shipping"
                            copy="Buy direct from us to always receive free shipping on all orders."
                        />
                        <OffersIcon
                            href={props.warranty_url}
                            imgSrc={guaranteeIcon(3)}
                            imgAlt=""
                            title="10 Year Warranty"
                            copy={
                                <>
                                    Our mattresses are covered by a 10 Year Full
                                    Replacement Limited Warranty.{" "}
                                </>
                            }
                        />
                    </ul>
                </div>
            </div>
            <section className="cta-block stitch-bg">
                <div className="main-container">
                    <h2>
                        130 years of quality. 40 million mattresses.
                        <br />
                        Feel the sealy difference for yourself.
                    </h2>
                    <a className="button" href={props.chill_url}>
                        shop foam
                    </a>
                    <a className="button" href={props.hybrid_url}>
                        shop hybrid
                    </a>
                </div>
            </section>
        </>
    );
};
